import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './baseQuery';

export interface IKyashConfig {
  enable_flag: number;
  dmoney_enable_flag: number;
  bank_enable_flag: number;
  commission: number;
  commission_kyash: number;
  description: string;
  transition_url: string | null;
}

export const kyashConfigApi = createApi({
  reducerPath: 'kyashConfig_api',
  tagTypes: ['kyashConfig'],
  baseQuery: axiosBaseQuery(),
  endpoints: build => ({
    getKyashConfig: build.query<IKyashConfig, string>({
      query: () => ({
        url: '/kyash_config',
        method: 'GET',
      }),
      transformResponse: (result: IKyashConfig) => result,
      providesTags: ['kyashConfig'],
    }),
    updateKyashConfig: build.mutation<IKyashConfig, IKyashConfig>({
      query: body => ({
        url: '/kyash_config',
        method: 'PUT',
        data: body,
      }),
      invalidatesTags: ['kyashConfig'],
    }),
  }),
});

export const { useGetKyashConfigQuery, useUpdateKyashConfigMutation } =
  kyashConfigApi;
